import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { Autocomplete, Button, CircularProgress, Dialog, DialogActions, DialogContent, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select, Switch, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import HomeIcon from '@mui/icons-material/Home';
import UndoIcon from '@mui/icons-material/Undo';

import { RootState } from '../../store';
import { openSnackbar } from '../../store/slices/SnackbarSlice';

import { Layout } from '../../components/Layout';
import { SearchTextField } from '../../components/SearchTextField';

import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { useFilter } from '../../hooks/useFilter';
import { usePages } from '../../hooks/usePages';

import { DialogActionsStyle, DialogContentStyle } from '../../styles/DialogStyle';
import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';

import { ActualizarAutoridad, AgregarAutoridad, AgregarDomicilio, Autoridades } from '../../connections/catalogos/AutoridadConnection';
import { ObtenerAsentamientosMunicipio } from '../../connections/catalogos/AsentamientoConnection';
import { ObtenerDistritoJudicial } from '../../connections/catalogos/DistritoJudicialConnection';
import { ObtenerEstados } from '../../connections/catalogos/EstadoConnection';
import { ObtenerMateria } from '../../connections/catalogos/MateriaConnection';
import { ObtenerMunicipio } from '../../connections/catalogos/MunicipioConnection';
import { ObtenerTipoDomicilio } from '../../connections/catalogos/TipoDomicilioConnection';
import { ObtenerUsuarioJuez } from '../../connections/admin/UsuarioConnection';

import { AsentamientoParser } from '../../interfaces/catalogos/AsentamientoInterface';
import { AutoridadDomicilioProps, AutoridadProps, AutoridadTitularProps } from '../../interfaces/catalogos/AutoridadInterface';
import { DistritoJudicialProps } from '../../interfaces/catalogos/DistritoJudicialInterface';
import { EstadoProps } from '../../interfaces/catalogos/EstadoInterface';
import { MateriaProps } from '../../interfaces/catalogos/MateriaInterface';
import { MunicipioProps } from '../../interfaces/catalogos/MunicipioInterface';
import { TipoDomicilioProps } from '../../interfaces/catalogos/TipoDomicilioInterface';
import { DomicilioProps } from '../../interfaces/comun/DomicilioInterface';
import { UsuarioJuezProps } from '../../interfaces/admin/UsuarioInterface';

type OptionType = 'Agregar' | 'Editar' | 'Agregar domicilio';

export const AutoridadPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [AutoridadArray, setAutoridadArray] = useState<AutoridadTitularProps[]>( [] );

    const [openDialog, setOpenDialog] = useState<boolean>( false );

    const [openDomicilio, setOpenDomicilio] = useState<boolean>( false );

    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );

    const [idAutoridad, setIdAutoridad] = useState( 0 );
    const [descripcion, setDescripcion] = useState( '' );

    const [referenciaPL, setReferenciaPL] = useState( '' );

    const [descripcionDomicilio, setDescripcionDomicilio] = useState<string>( '' );
    const [numero, setNumero] = useState<string>( '' );
    const [referenciaDomicilio, setReferenciaDomicilio] = useState<string>( '' );

    const [autocompleteValue, setAutocompleteValue] = useState<AsentamientoParser | null>( null );

    const [distritoJudicial, setDistritoJudicial] = useState( 0 );
    const [distritoJudicialArray, setDistritoJudicialArray] = useState<DistritoJudicialProps[]>( [] );

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [estado, setEstado] = useState( 0 );
    const [estadoArray, setEstadoArray] = useState<EstadoProps[]>( [] );

    const [municipio, setMunicipio] = useState( 0 );
    const [municipioArray, setMunicipioArray] = useState<MunicipioProps[]>( [] );

    const [tipoDomicilio, setTipoDomicilio] = useState( 0 );
    const [tipoDomicilioArray, setTipoDomicilioArray] = useState<TipoDomicilioProps[]>( [] );

    const [asentamiento, setAsentamiento] = useState( 0 );
    const [asentamientoArray, setAsentamientoArray] = useState<AsentamientoParser[]>( [] );

    const [titular, setTitular] = useState( 0 );
    const [titularArray, setTitularArray] = useState<UsuarioJuezProps[]>( [] );

    const [domicilio, setDomicilio] = useState<DomicilioProps>({});

    const [opcion, setOpcion] = useState<OptionType>( 'Agregar' );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages(5);

    const [filtroMateria, setFiltroMateria] = useState( '' );
    const [filtroDistritoJudicial, setFiltroDistritoJudicial] = useState( '' );

    const { filtro, setFiltro, dataFiltrada } = useFilter( AutoridadArray, ( item, filtro ) => {
        const f = filtro.toLowerCase();
        const fm = filtroMateria.toLowerCase();
        const fdj = filtroDistritoJudicial.toLowerCase();
        return (
            ( filtro === '' || ( item.descripcion?.toLowerCase().includes( f ) ?? false ) ) &&
            ( filtroMateria === '' || ( item.materia?.descripcion?.toLowerCase().includes( fm ) ?? false ) ) &&
            ( filtroDistritoJudicial === '' || ( item.distritoJudicial?.descripcion?.toLowerCase().includes( fdj ) ?? false ) )
        );
    });

    const handleCloseDialogDomicilio = () => {

        setOpenDomicilio( false );
        setEstado( 0 );
        setMunicipio( 0 );
        setAsentamiento( 0 );
        setTipoDomicilio( 0 );
        setDescripcionDomicilio( '' );
        setNumero( '' );
        setReferenciaDomicilio( '' );
        setDomicilio({});
        setAsentamientoArray( [] );
        setMunicipioArray( [] );
        setAutocompleteValue( null );

    }

    const AgregarRegistro = () => {

        setMateria( 0 );
        setDistritoJudicial( 0 );
        setDescripcion( '' );
        setReferenciaPL( '' );
        setOpcion( 'Agregar' );
        setIdAutoridad( 0 );
        setTitular( 0 );
        setOpenDialog( true );

    }

    const EditarRegistro = ({ idAutoridad, referenciaPL, descripcion, idMateria, idDistritoJudicial, idTitular }: AutoridadProps) => {

        setDescripcion(descripcion);
        setMateria(idMateria);
        setDistritoJudicial(idDistritoJudicial);
        setReferenciaPL( referenciaPL?.toString() ?? '' );
        setOpcion( 'Editar' );
        setIdAutoridad(idAutoridad);
        setTitular( idTitular ?? 0 );
        setOpenDialog( true );
    }

    const handleChangeChecked = async (checked: boolean, id: number) => {

        const autoridadSelected = AutoridadArray.find( (elem) => elem.idAutoridad === id );

        if ( autoridadSelected ) {

            await ActualizarAutoridad({ ...autoridadSelected, activo: checked }).then(resp => {

                if ( resp.idAutoridad ) {

                    var newArray = AutoridadArray.map((elem) => {

                        if (elem.idAutoridad === id) {
                            elem.activo = checked;
                        }

                        return elem;
                    });

                    setAutoridadArray(newArray);

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                }

            });
        }

    }

    const handleGuardar = async () => {

        setLoading( true )

        if ( opcion === 'Editar' ) {

            const autoridad = AutoridadArray.find( (row ) => row.idAutoridad === idAutoridad );

            const params: AutoridadProps = {
                idAutoridad: idAutoridad,
                idDistritoJudicial: distritoJudicial,
                idMateria: materia,
                referenciaPL: referenciaPL === '' ? 0 : parseInt(referenciaPL),
                descripcion: descripcion.trim(),
                activo: autoridad?.activo ?? false,
                idTitular: titular,
            };

            await ActualizarAutoridad( params ).then( resp => {

                if ( resp ) {

                    setTimeout(() => {

                        const newRows = AutoridadArray.map( ( row ) => {

                            if ( row.idAutoridad === idAutoridad ) {

                                row.referenciaPL = resp.referenciaPL;
                                row.descripcion = descripcion;
                                row.idMateria = resp.idMateria;
                                row.materia = resp.materia;
                                row.idDistritoJudicial = resp.idDistritoJudicial;
                                row.distritoJudicial = resp.distritoJudicial;
                                row.activo = resp.activo;
                                row.idTitular = titular;
                                row.titular = resp.titular;
                                return row;
                            }

                            return row;
                        });

                        setAutoridadArray(newRows);

                        setLoading( false );
                        setOpenDialog( false );

                        dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                    }, 400);

                }

            });
        }
        else if ( opcion === 'Agregar' ) {

            const params: AutoridadProps = {
                idAutoridad: 0,
                idDistritoJudicial: distritoJudicial,
                idMateria: materia,
                referenciaPL: referenciaPL === '' ? 0 : parseInt(referenciaPL),
                descripcion: descripcion.trim(),
                activo: true,
                idTitular: titular,
            };

            await AgregarAutoridad( params ).then( resp => {

                if ( resp ) {

                    setTimeout(() => {

                        setAutoridadArray([ ...AutoridadArray, resp ]);

                        setLoading( false );
                        setOpenDialog( false );

                        dispatch( openSnackbar({ message: 'Se agregó la autoridad correctamente', variant: 'success' }));

                    }, 400);

                }

            });
        }

    }

    const EditarDomicilio = ({ idAutoridad, domicilio }: AutoridadProps) => {

        setIdAutoridad( idAutoridad );
        setOpenDomicilio( true );

        if ( domicilio ) {
            setDomicilio( domicilio );
        }

    }

    const GuardarDomicilio = async () => {

        setLoading( true );

        const params: AutoridadDomicilioProps = {
            idAutoridad: idAutoridad,
            idDomicilio: domicilio.idDomicilio ?? 0,
            descripcion: descripcionDomicilio,
            numero: numero,
            referencia: referenciaDomicilio,
            idAsentamiento: asentamiento,
            idTipoDomicilio: tipoDomicilio,
        };

        await AgregarDomicilio(params).then(resp => {

            if ( resp ) {

                setTimeout(() => {

                    const newRows = AutoridadArray.map(( row ) => {

                        if ( row.idAutoridad === idAutoridad ) {
                            row.domicilio = resp;
                        }

                        return row;
                    });

                    setAutoridadArray( newRows );
                    setLoading( false );
                    handleCloseDialogDomicilio();

                    dispatch( openSnackbar({ message: 'Se agregó el domicilio correctamente', variant: 'success' }));

                }, 400);

            }

        });
    }

    useEffect(() => {

        async function obtener() {

            setLoadingData( true );
            setAutoridadArray( [] );

            await Autoridades().then(resp => {

                setTimeout(() => {

                    setAutoridadArray(resp);
                    setLoadingData( false );

                }, 700);

            });

        }

        obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerDistritoJudicial().then(resp => {
                setDistritoJudicialArray(resp);
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then(resp => {
                setMateriaArray(resp);
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerUsuarioJuez().then(resp => {
                setTitularArray(resp);
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerEstados().then(resp => {
                setEstadoArray(resp);
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setMunicipio( 0 );
            setMunicipioArray( [] );

            if ( estado !== 0 ) {

                await ObtenerMunicipio( estado ).then( resp => {
                    setMunicipioArray(resp);
                });

            }

        }

        Obtener();

    }, [estado]);

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoDomicilio().then(resp => {
                setTipoDomicilioArray(resp);
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setAsentamiento( 0 );
            setAsentamientoArray( [] );

            if ( municipio !== 0 ) {

                await ObtenerAsentamientosMunicipio(municipio).then(resp => {
                    setAsentamientoArray(resp);
                });

            }

        }

        Obtener();

    }, [municipio]);

    useEffect(() => {

        if (Object.keys(domicilio).length !== 0) {

            setEstado(domicilio.asentamiento?.idEstado ?? 0);
            setTipoDomicilio(domicilio.idTipoDomicilio ?? 0);
            setDescripcionDomicilio(domicilio.descripcion ?? '');
            setNumero(domicilio.numero ?? '');
            setReferenciaDomicilio(domicilio.referencia ?? '');

        }

    }, [domicilio]);

    useEffect(() => {

        if (Object.keys(domicilio).length !== 0) {

            setMunicipio( 0 );

            if (municipioArray.length > 0 && domicilio.asentamiento?.idEstado === estado) {
                setMunicipio(domicilio.asentamiento?.idMunicipio ?? 0);
            }

        }

    }, [domicilio, estado, municipioArray]);

    useEffect(() => {

        if (Object.keys(domicilio).length !== 0) {

            setAsentamiento( 0 );

            if (asentamientoArray.length > 0) {
                setAsentamiento(domicilio.idAsentamiento ?? 0);

                const asent = asentamientoArray.find((e) => e.idAsentamiento === domicilio?.idAsentamiento);

                if (asent) {
                    setAutocompleteValue(asent);
                }

            }
        }

    }, [domicilio, asentamientoArray]);

    return (

        <Layout breadcrumbs={ [ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Autoridad' } ] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                <Grid size={{ md: 6, xs: 12 }} textAlign={ 'start' }>

                    {
                        ( administrador || coordinador )
                        &&
                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate('/') }>
                                Regresar
                            </Button>
                    }

                </Grid>

                <Grid size={{ md: 6, xs: 12 }} textAlign={ 'end' }>

                    <Button
                        type='button'
                        variant='contained'
                        sx={{ mt: 1 }}
                        disabled={ loadingData }
                        onClick={ AgregarRegistro }
                    >
                        Agregar
                    </Button>

                </Grid>

            </Grid>

            <Grid container sx={{ mt: 2 }} spacing={ 2 }>

                <Grid size={{ xs: 12, md: 4 }}>

                    <SearchTextField
                        value={ filtro }
                        label='Buscar por descripción'
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>

                    <SearchTextField
                        value={ filtroMateria }
                        label='Buscar por materia'
                        onChange={ ( value ) => {
                            setFiltroMateria( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>

                    <SearchTextField
                        value={ filtroDistritoJudicial }
                        label='Buscar por distrito judicial'
                        onChange={ ( value ) => {
                            setFiltroDistritoJudicial( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '5%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '35%' }}> Descripción </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%' }}> Materia </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%' }}> Distrito judicial </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', textAlign: 'center' }}> Referencia Poder <br /> en Línea </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', textAlign: 'center' }}> Domicilio </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%' }}> </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                    ?
                                    dataFiltrada.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    :
                                    dataFiltrada
                            )
                                .map(({ idAutoridad, descripcion, activo, referenciaPL, distritoJudicial, materia, idMateria, idDistritoJudicial, domicilio, idTitular, titular }) => (

                                    <TableRow key={ idAutoridad } >

                                        <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                            { idAutoridad }
                                        </TableCell>

                                        <TableCell>
                                            <Typography variant='h6' fontWeight={ 'normal' } fontSize={ 14 } mt={ 1 }>{ descripcion }</Typography>

                                            {
                                                titular
                                                &&
                                                    <Typography variant='h6' fontSize={ 12 } mt={ 1 }><strong>TITULAR:</strong> { titular }</Typography>
                                            }

                                        </TableCell>

                                        <TableCell>
                                            {materia?.descripcion}
                                        </TableCell>

                                        <TableCell>
                                            {distritoJudicial?.descripcion}
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                            {referenciaPL ? <>({ referenciaPL })</> : ''}
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'center' }}>
                                            <IconButton
                                                color='primary'
                                                aria-label='home'
                                                component='span'
                                                onClick={ () => EditarDomicilio({ idAutoridad, referenciaPL, descripcion, idMateria, idDistritoJudicial, activo, domicilio }) }
                                            >
                                                <HomeIcon />
                                            </IconButton>
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'end' }}>

                                            <Switch
                                                checked={ activo }
                                                onChange={ (e) => handleChangeChecked( e.target.checked, idAutoridad ) }
                                            />

                                            <IconButton
                                                color='primary'
                                                aria-label='edit'
                                                component='span'
                                                onClick={ () => EditarRegistro({ idAutoridad, referenciaPL, descripcion, idMateria, idDistritoJudicial, activo, idTitular }) }
                                            >
                                                <EditIcon />
                                            </IconButton>

                                        </TableCell>

                                    </TableRow>

                                ))
                        }

                        {
                            (dataFiltrada.length === 0 && !loadingData)
                                ?
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={ 7 } align='center'>

                                        <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                    </TableCell>

                                </TableRow>
                                :
                                loadingData
                                &&
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={ 7 } align='center'>

                                        <CircularProgress size={ 32 } />

                                    </TableCell>

                                </TableRow>
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                            <TableRow>

                                <TableCell colSpan={ 2 } sx={{ border: 'none' }}>
                                    <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                        Total de registros: { dataFiltrada.length }
                                    </Typography>
                                </TableCell>

                                <TablePagination
                                    sx={{ border: 'none' }}
                                    rowsPerPageOptions={ [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ] }
                                    colSpan={ 8 }
                                    count={ dataFiltrada.length }
                                    rowsPerPage={ rowsPerPage }
                                    page={ page }

                                    onPageChange={ handleChangePage }
                                    onRowsPerPageChange={ handleChangeRowsPerPage }

                                    ActionsComponent={ TablePaginationActions }

                                    labelRowsPerPage='Filas por página'
                                    labelDisplayedRows={
                                        ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                        }
                                    }
                                />

                            </TableRow>
                        }

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog
                maxWidth='sm'
                open={ openDialog }
                fullWidth={ true }
            >

                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={ 3 } sx={{ mt: 3 }}>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <FormControl fullWidth>

                                <InputLabel>Distrito Judicial</InputLabel>
                                <Select
                                    label='Distrito Judicial'
                                    value={ distritoJudicial }
                                    onChange={ (e) => { setDistritoJudicial( e.target.value ?? 0 ); } }

                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        distritoJudicialArray.map((elem) => (
                                            <MenuItem key={ elem.idDistritoJudicial } value={ elem.idDistritoJudicial }> { elem.descripcion } </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <FormControl fullWidth>

                                <InputLabel>Materia</InputLabel>

                                <Select
                                    label='Materia'
                                    value={ materia }
                                    onChange={ (e) => { setMateria( e.target.value ?? 0 ); } }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        materiaArray.map((elem) => (
                                            <MenuItem key={ elem.idMateria } value={ elem.idMateria }> { elem.descripcion } </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <FormControl fullWidth>

                                <InputLabel>Titular</InputLabel>

                                <Select
                                    label='Titular'
                                    value={ titular }
                                    onChange={ (e) => setTitular( e.target.value ?? 0 ) }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        titularArray.map((elem) => (
                                            <MenuItem key={ elem.idUsuario } value={ elem.idUsuario }> { elem.nombreCompleto } </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <TextField
                                fullWidth
                                label={ 'Referencia en Poder en Línea' }
                                variant='outlined'
                                type='number'
                                value={ referenciaPL }
                                onChange={ (e) => { setReferenciaPL( e.target.value ) } }
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}
                            />

                        </Grid>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <TextField
                                label={ 'Descripción' }
                                variant='outlined'
                                multiline
                                rows={ 4 }
                                fullWidth
                                value={ descripcion }
                                onChange={ (e) => setDescripcion( e.target.value ) }
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}
                            />

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color='secondary' disabled={ loading } onClick={ () => setOpenDialog( false ) }> Cancelar </Button>
                    <Button
                        variant='contained'
                        loading={ loading }
                        disabled={ descripcion === '' || materia === 0 || distritoJudicial === 0 }
                        onClick={ handleGuardar }
                    >
                        Guardar
                    </Button>
                </DialogActions>

            </Dialog>

            <Dialog
                maxWidth='sm'
                open={ openDomicilio }
                fullWidth={ true }
            >

                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={ 3 } sx={{ mt: 3 }}>

                        <Grid size={ 6 }>

                            <FormControl fullWidth>
                                <InputLabel id="select-estado-label">Estado</InputLabel>

                                <Select
                                    labelId="select-estado-label"
                                    id="select-estado"
                                    label='Estado'
                                    name="estado"
                                    value={ estado }
                                    onChange={ (e) => { setEstado( e.target.value ?? 0 ); } }

                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        estadoArray.map((elem) => (
                                            <MenuItem key={ elem.idEstado } value={ elem.idEstado }> { elem.descripcion } </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={ 6 }>

                            <FormControl fullWidth>

                                <InputLabel id="select-municipio-label">Municipio</InputLabel>

                                <Select
                                    labelId="select-municipio-label"
                                    id="select-municipio"
                                    label='Municipio'
                                    name="municipio"
                                    value={ municipio }
                                    onChange={ (e) => { setMunicipio( e.target.value ?? 0 ); } }
                                    disabled={ estado === 0 }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        municipioArray.map((elem) => (
                                            <MenuItem key={ elem.idMunicipio } value={ elem.idMunicipio }> { elem.descripcion } </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={ 12 }>

                            <FormControl fullWidth >

                                <Autocomplete
                                    disabled={ municipio === 0 }
                                    disablePortal
                                    fullWidth
                                    value={ autocompleteValue }
                                    options={ asentamientoArray }
                                    onChange={ (event, value) => { setAsentamiento( value?.idAsentamiento ?? 0 ); setAutocompleteValue( value ); } }
                                    getOptionLabel={ (option) => option.asentamiento }
                                    renderOption={ (props, option) => (
                                        <li {...props} key={ option.idAsentamiento } >
                                            <strong>{ option.asentamiento }</strong>&nbsp;(C.P. { option.codigoPostal }) - { option.tipo }
                                        </li>
                                    ) }
                                    renderInput={ (params) => <TextField {...params} label='Asentamiento' placeholder='Seleccione una opción' InputLabelProps={{ shrink: true }} /> }
                                />

                            </FormControl>

                        </Grid>

                        <Grid size={ 12 }>

                            <FormControl fullWidth>
                                <InputLabel id="select-tipoDomicilio-label">Tipo Domicilio</InputLabel>

                                <Select
                                    labelId="select-tipoDomicilio-label"
                                    id="select-tipoDomicilio"
                                    label='Tipo Domicilio'
                                    name="tipoDomicilio"
                                    value={ tipoDomicilio }
                                    onChange={ (e) => { setTipoDomicilio( e.target.value ?? 0 ); } }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        tipoDomicilioArray.map((elem) => (
                                            <MenuItem key={ elem.idTipoDomicilio } value={ elem.idTipoDomicilio }> { elem.descripcion } </MenuItem>

                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={ 8 } >

                            <FormControl fullWidth>

                                <TextField
                                    label={ 'Descripción' }
                                    variant='outlined'
                                    multiline
                                    fullWidth
                                    minRows={ 1 }
                                    maxRows={ 3 }
                                    value={ descripcionDomicilio }
                                    onChange={ (e) => setDescripcionDomicilio( e.target.value ) }
                                    slotProps={{
                                        input: {
                                            autoComplete: 'off'
                                        },
                                        inputLabel: {
                                            shrink: true,
                                        }
                                    }}
                                />

                            </FormControl>

                        </Grid>

                        <Grid size={ 4 }>

                            <FormControl fullWidth>

                                <TextField
                                    label={ 'Númer Int./Ext' }
                                    variant='outlined'
                                    multiline
                                    fullWidth
                                    minRows={ 1 }
                                    maxRows={ 3 }
                                    value={ numero }
                                    onChange={ (e) => { setNumero( e.target.value ) } }
                                    slotProps={{
                                        input: {
                                            autoComplete: 'off'
                                        },
                                        inputLabel: {
                                            shrink: true,
                                        }
                                    }}
                                />

                            </FormControl>

                        </Grid>

                        <TextField
                            label={ 'Referencia del domicilio' }
                            variant='outlined'
                            multiline
                            fullWidth
                            rows={ 4 }
                            value={ referenciaDomicilio }
                            onChange={ (e) => { setReferenciaDomicilio( e.target.value ) } }
                            slotProps={{
                                input: {
                                    autoComplete: 'off'
                                },
                                inputLabel: {
                                    shrink: true,
                                }
                            }}
                        />

                    </Grid>
                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button disabled={ loading } onClick={ handleCloseDialogDomicilio }> Cancelar </Button>
                    <Button
                        variant='contained'
                        loading={ loading }
                        disabled={ descripcionDomicilio === '' || estado === 0 || municipio === 0 || autocompleteValue === null || tipoDomicilio === 0 || numero === "" }
                        onClick={ GuardarDomicilio }
                    >
                        Guardar
                    </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}